import { Component, OnInit } from '@angular/core';
import * as Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import { AnalyticsService } from '../../../../services/analytics.service';
import { PublishedReportCountsByYear } from "../../../../models/analytics.model";
HC_more(Highcharts);

@Component({
  selector: 'app-report-counts-five-year-card',
  templateUrl: './report-counts-five-year-card.component.html',
  styleUrls: ['./report-counts-five-year-card.component.css']
})
export class ReportCountsFiveYearCardComponent implements OnInit {

  updateFromInput: boolean = false;
  publishedReportCountsByYear: PublishedReportCountsByYear[];

  FiveYearLineChart: typeof Highcharts = Highcharts;
  fiveYearLineChartOptions:any;   // the actual value should be Highcharts.Options. it does not build with that.

  reportYearList: number[] = [];
  publishedReportCountRequiredPublicList: number[] = [];
  publishedReportCountRequiredInternalList: number[] = [];
  publishedReportCountVoluntaryPublicList: number[] = [];
  publishedReportCountVoluntaryInternalList: number[] = [];

  selectedReportYear: number;  
  constructor( private analyticsService: AnalyticsService ) { }

  ngOnInit() {  }



  loadChart(yearId:number,year:number)
  {

   this.selectedReportYear = year;
   this.analyticsService.getPublishedReportCountsByYear$(yearId,5).subscribe((data)=>{
      
      //console.log(data);


      this.publishedReportCountsByYear = data;
     // console.log(this.publishedReportCountsByYear);
     // console.log(this.publishedReportCountsByYear.length);

      this.reportYearList = [];
      this.publishedReportCountRequiredPublicList = [];
      this.publishedReportCountRequiredInternalList = [];
      this.publishedReportCountVoluntaryPublicList = [];
      this.publishedReportCountVoluntaryInternalList = [];
      
      for (let index = 0; index < this.publishedReportCountsByYear.length; index++) {
        this.reportYearList.push(this.publishedReportCountsByYear[index].reportYear);
        this.publishedReportCountRequiredPublicList.push(this.publishedReportCountsByYear[index].requiredPublicReportCount);
        this.publishedReportCountRequiredInternalList.push(this.publishedReportCountsByYear[index].requiredInternalReportCount);
        this.publishedReportCountVoluntaryPublicList.push(this.publishedReportCountsByYear[index].voluntaryPublicReportCount);
        this.publishedReportCountVoluntaryInternalList.push(this.publishedReportCountsByYear[index].voluntaryInternalReportCount);

      };

     
      this.GetChartOptions();
      this.updateChart();
      
    });

  }


updateChart()
{
  this.updateFromInput = true;
}

GetChartOptions()
{
    this.fiveYearLineChartOptions=
    {
      chart: {
          type: 'line',
          borderColor: null,
          borderWidth: 1,
          width:450,
          height:375
      },

      title: {
          text: 'Published Report Counts for ' + (this.selectedReportYear - 4) + '-' + this.selectedReportYear ,
          style:{"color":"#337ab7","fontSize":"16px","fontWeight":"bold" }
      },
   
      tooltip: {
        formatter: function () {
            return '</b>' + this.y + '</b>';
        }
    },

      xAxis: {
          categories: this.reportYearList
      },

      yAxis: {
          title: {
              text: 'No. Of Reports'
          }
      },

      plotOptions: {
          line: {
              dataLabels: {
                  enabled: true
              }
          }
      },

      credits:{
        enabled:false
      },

      series:  [{
            type: 'line',
            name: 'Required-Public',
            data: this.publishedReportCountRequiredPublicList,
            color: Highcharts.getOptions().colors[7] 
        }, {
            type: 'line',
            name: 'Required-Internal',
            data: this.publishedReportCountRequiredInternalList,
            color: Highcharts.getOptions().colors[8] 
        }, {
            type: 'line',
            name: 'Voluntary-Public',
            data: this.publishedReportCountVoluntaryPublicList,
            color: Highcharts.getOptions().colors[3] 
        }, {
            type: 'line',
            name: 'Voluntary-Internal',
            data: this.publishedReportCountVoluntaryInternalList,
            color: Highcharts.getOptions().colors[2] 
        }]
    };

}
}